// extracted by mini-css-extract-plugin
export default {"container":"SubBrowse_container__GqpvP","shop":"SubBrowse_shop__qTLRG","shopItem":"SubBrowse_shopItem__XHxSb","emptyMsg":"SubBrowse_emptyMsg__R1Qb-"};